/**
 * @generated SignedSource<<6f8b3d0d9a3c44470740c96a3b8e0ea9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunNovaAgentProductionInput = {
  id: string;
  taskId: string;
  message?: string | null;
  threadId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RunNovaAgentProductionMutation$variables = {
  input: RunNovaAgentProductionInput;
};
export type RunNovaAgentProductionMutation$data = {
  readonly runNovaAgentProduction: {
    readonly result: {
      readonly run: {
        readonly outcome: string | null;
        readonly status: string | null;
        readonly failureState: string | null;
      } | null;
    } | null;
  } | null;
};
export type RunNovaAgentProductionMutation = {
  variables: RunNovaAgentProductionMutation$variables;
  response: RunNovaAgentProductionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outcome",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failureState",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RunNovaAgentProductionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RunNovaAgentProductionPayload",
        "kind": "LinkedField",
        "name": "runNovaAgentProduction",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaRunResult",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentRun",
                "kind": "LinkedField",
                "name": "run",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RunNovaAgentProductionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RunNovaAgentProductionPayload",
        "kind": "LinkedField",
        "name": "runNovaAgentProduction",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaRunResult",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentRun",
                "kind": "LinkedField",
                "name": "run",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4a313afc911122df76c445904632ac8",
    "id": null,
    "metadata": {},
    "name": "RunNovaAgentProductionMutation",
    "operationKind": "mutation",
    "text": "mutation RunNovaAgentProductionMutation(\n  $input: RunNovaAgentProductionInput!\n) {\n  runNovaAgentProduction(input: $input) {\n    result {\n      run {\n        outcome\n        status\n        failureState\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6cae629635928723f2aeaf1820f9bca0";

export default node;
